import { Box, Skeleton, Stack } from '@mui/material';
import { Container } from '../../../components/container';

export const MapSkeleton = () => (
  <Container>
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
      <Skeleton variant="circular" width={40} height={40} sx={{ mr: 2 }} />
      <Skeleton variant="text" width={150} height={40} />
    </Box>

    <Box sx={{ position: 'relative', width: '100%', height: '600px', borderRadius: 2, overflow: 'hidden' }}>
      <Skeleton variant="rectangular" width="100%" height="100%" sx={{ borderRadius: 2 }} />

      <Stack spacing={1} sx={{ position: 'absolute', top: 16, right: 16 }}>
        <Skeleton variant="rectangular" width={40} height={40} sx={{ borderRadius: 1 }} />
        <Skeleton variant="rectangular" width={40} height={40} sx={{ borderRadius: 1 }} />
      </Stack>

      <Box sx={{ position: 'absolute', top: 16, left: 16 }}>
        <Skeleton variant="rectangular" width={300} height={48} sx={{ borderRadius: 3 }} />
      </Box>

      <Stack spacing={0.5} sx={{ position: 'absolute', bottom: 16, right: 16 }}>
        <Skeleton variant="rectangular" width={40} height={40} sx={{ borderRadius: 1 }} />
        <Skeleton variant="rectangular" width={40} height={40} sx={{ borderRadius: 1 }} />
      </Stack>

      <Box sx={{ position: 'absolute', bottom: 16, left: 16 }}>
        <Skeleton variant="rectangular" width={200} height={60} sx={{ borderRadius: 2 }} />
      </Box>
    </Box>
  </Container>
);
